import { render, staticRenderFns } from "./MatchPredictions.vue?vue&type=template&id=37480076&scoped=true&"
import script from "./MatchPredictions.vue?vue&type=script&lang=js&"
export * from "./MatchPredictions.vue?vue&type=script&lang=js&"
import style0 from "./MatchPredictions.vue?vue&type=style&index=0&id=37480076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37480076",
  null
  
)

export default component.exports